import {
  GET_BANKLIST_SUCCESS,
  GET_BANKLIST_FAILED,
  GET_BANKLIST_INVALID_WALLET_ID,
  GET_BANKLIST_INVALID_TOKEN,
  RESET_GET_BANKLIST,
  LOADING_GET_BANKLIST,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  notFound: false,
  invalidToken: false,
  bankList: [],
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_BANKLIST:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        notFound: false,
        invalidToken: false,
        status: "",
        networkError: "",
      };

    case GET_BANKLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        notFound: false,
        invalidToken: false,
        status: action.payload.status,
        networkError: "",
      };

    case GET_BANKLIST_INVALID_TOKEN:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: false,
        invalidToken: true,
        status: action.payload.status,
        networkError: "",
      };

    case GET_BANKLIST_INVALID_WALLET_ID:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        notFound: true,
        invalidToken: false,
        status: action.payload.status,
        networkError: "",
      };

    case GET_BANKLIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        notFound: false,
        invalidToken: false,
        bankList: [].concat(action.payload.bankList),
        networkError: "",
      };
    }

    case RESET_GET_BANKLIST:
      return (state = initialState);

    default:
      return state;
  }
};
